"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownChips = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _molecules = require("../../molecules");

var _uuid = require("uuid");

var _atoms = require("../../atoms");

var _classnames = _interopRequireDefault(require("classnames"));

var _images = require("../../assets/images");

var _utils = require("../../shared/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const DropdownChips = ({
  chipsName,
  chipsType,
  multiSelectOptions,
  onChange,
  children,
  customTitle,
  width,
  flyoutWidth,
  placement,
  showClearButton,
  onClear
}) => {
  // Common state
  const [showOptions, setShowOptions] = (0, _react.useState)(false);
  const [chipsTitle, setChipsTitle] = (0, _react.useState)(chipsName);
  const flyoutId = (0, _react.useMemo)(() => (0, _uuid.v4)(), []); // Multi select type dropdown state

  const [selectedChips, setSelectedChips] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    if (chipsType.toUpperCase() === 'multi-select'.toUpperCase()) {
      setSelectedChips(multiSelectOptions.filter(option => option.isChecked).map(option => option.id));
    }
  }, [chipsType, multiSelectOptions]);

  const chipsClickHandler = () => setShowOptions(show => !show);

  const multiSelectOptionClickHandler = (0, _react.useCallback)((e, id) => {
    const {
      checked
    } = e.target;
    let options = [];

    if (checked) {
      setSelectedChips(() => {
        return [...selectedChips, id];
      });
      options = multiSelectOptions.filter(item => {
        delete item.isChecked;
        return [...selectedChips, id].includes(item.id) && item;
      });
    } else {
      setSelectedChips(() => {
        return selectedChips.filter(index => index !== id);
      });
      options = multiSelectOptions.filter(item => {
        delete item.isChecked;
        return selectedChips.filter(index => index !== id).includes(item.id) && item;
      });
    }

    (0, _utils.isFunction)(onChange) && onChange(options);
  }, [selectedChips]);

  const clearOptions = event => {
    event.stopPropagation();

    if (chipsType && chipsType.toUpperCase() === 'multi-select'.toUpperCase()) {
      setSelectedChips([]);
      setShowOptions(false);
      setChipsTitle(chipsName);
    } else if (chipsType && chipsType.toUpperCase() === 'multi-input'.toUpperCase()) {
      // Call user's passed on clear method
      onClear && onClear();
    }
  };

  const getChipsInitialTitle = () => {
    // Render custom title if provided else keep default behaviour
    return customTitle || chipsTitle;
  };

  (0, _react.useEffect)(() => {
    /*
    	1. If there are selected options then update name of chips to joint comma
    	separated name of selected options
    2. If all options are selected, show initials of chips name appended
    	with 'All'
    3. Otherwise use provided default chips name
    */
    selectedChips && selectedChips.length && selectedChips.length === multiSelectOptions.length ? setChipsTitle(`${chipsName}: All`) : selectedChips && selectedChips.length ? setChipsTitle(`${multiSelectOptions.filter(item => selectedChips.includes(item.id) && item).map(item => item['name']).join(',')}`) : setChipsTitle(chipsName);
  }, [chipsName, multiSelectOptions, selectedChips]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.StyledChipsDiv, {
    id: flyoutId,
    onClick: chipsClickHandler,
    width: width,
    showOptions: showOptions,
    showClearButton: showClearButton
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledChipsTitleDiv, null, getChipsInitialTitle()), /*#__PURE__*/_react.default.createElement(_styles.StyledChipsIconWrapperDiv, null, /*#__PURE__*/_react.default.createElement(_styles.StyledChipsIconDiv, {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      isOpen: showOptions
    })
  }, /*#__PURE__*/_react.default.createElement(_images.DownArrow, null))), showClearButton && /*#__PURE__*/_react.default.createElement(_styles.StyledChipsIconDiv, {
    className: "icon",
    onClick: clearOptions
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_images.Close, null))))), /*#__PURE__*/_react.default.createElement(_molecules.Flyout, {
    show: showOptions,
    className: "primary",
    id: flyoutId,
    offset: 10,
    placement: placement,
    width: flyoutWidth ? flyoutWidth : '200px',
    overflow: "visible"
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledFlyoutDiv, {
    multiInput: chipsType && chipsType.toUpperCase() === 'multi-input'.toUpperCase()
  }, chipsType && chipsType.toUpperCase() === 'multi-select'.toUpperCase() ? // Multi Select Component
  multiSelectOptions && multiSelectOptions.map((option, idx) => /*#__PURE__*/_react.default.createElement(_styles.StyledCheckboxDiv, {
    key: idx
  }, /*#__PURE__*/_react.default.createElement(_atoms.Checkbox, {
    key: idx,
    label: option.name,
    onChange: e => multiSelectOptionClickHandler(e, option.id),
    value: option.name,
    checked: selectedChips.includes(option.id)
  }))) : chipsType && chipsType.toUpperCase() === 'multi-input'.toUpperCase() ? // Multi Input component
  children : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null))));
};

exports.DropdownChips = DropdownChips;
DropdownChips.defaultProps = {
  chipsType: 'multi-select',
  multiSelectOptions: [],
  chipsName: 'Chips Name',
  placement: 'leftTop'
};
DropdownChips.propTypes = {
  /** Chips type i.e multi-select / multi-input */
  chipsType: _propTypes.default.oneOf(['multi-select', 'multi-input']).isRequired,

  /** Chips title */
  chipsName: _propTypes.default.string.isRequired,

  /**
   * 1. Multi select options array [Only for multi-select type dropdown]
   * 2. isChecked represent initial value for checkbox
   */
  multiSelectOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    name: _propTypes.default.string,
    isChecked: _propTypes.default.bool
  })),

  /** On change handler for checkbox in multi-select dropdown (selectedItems)=>{}*/
  onChange: _propTypes.default.func,

  /** Child components [Only for multi-input type dropdown] */
  children: _propTypes.default.node,

  /**
   * Custom title for chips when there are selected values.
   * Otherwise, title will be computed automatically, using selected values.
   */
  customTitle: _propTypes.default.string,

  /** Width of chips */
  width: _propTypes.default.string,

  /** Width of options popup */
  flyoutWidth: _propTypes.default.string,

  /** Flyout position */
  placement: _propTypes.default.string,

  /** Show clear chips button */
  showClearButton: _propTypes.default.bool,

  /** On clear chips handler [Only for multi-input type dropdown]*/
  onClear: _propTypes.default.func
};